<template>
  <el-dropdown trigger="click" @command="handleSetLanguage">
    <span class="el-dropdown-link">
      <i class="fas fa-globe"></i>
      {{ currentLanguage }}
    </span>
    <el-dropdown-menu slot="dropdown">
      <el-dropdown-item command="cn">中文</el-dropdown-item>
      <el-dropdown-item command="en">English</el-dropdown-item>
    </el-dropdown-menu>
  </el-dropdown>
</template>

<script>
export default {
  name: 'LanguageSelector',
  computed: {
    currentLanguage() {
      return this.$i18n.locale === 'cn' ? '中文' : 'English'
    }
  },
  methods: {
    handleSetLanguage(lang) {
      this.$i18n.locale = lang
      localStorage.setItem('language', lang)
      location.reload() // 刷新页面以确保所有组件都更新语言
    }
  }
}
</script>

<style scoped>
.el-dropdown-link {
  cursor: pointer;
  font-size: 16px;
  margin-left: 10px;
}
.fa-globe {
  margin-right: 4px;
  font-size: 16px;
}
</style>
 